import React from 'react';
import { MainPageCore } from '@core-front/main';
import Image from '@telia-front/image';
import ObjectFit from '@telia-front/object-fit';
const MainPage = (props) => {
    const { children, backgroundImage, className } = props;
    const BEM = () => {
        const classArray = [];
        if (backgroundImage) {
            classArray.push('main__page--with-background');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getBackgroundImage = (image) => (React.createElement("div", { className: "main__page--background" },
        React.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" },
            React.createElement(Image, Object.assign({}, image, { className: "main__page--background-image", pictureClassName: "main__page--background-picture", width: 500 })))));
    return (React.createElement(MainPageCore, { className: BEM() },
        backgroundImage && getBackgroundImage(backgroundImage),
        children));
};
export default MainPage;
